module.exports = __webpack_public_path__ + "static/media/squareFormat.c50f2dd1.svg";